export default __webpack_public_path__ + "static/media/363.a0cac434.png";